import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { orderAPI } from "../../api/service";
import { IAvailableHours, IGetAllOrderResponse, IMaintenanceOrderFilterData } from "../../api/maintenance-order/order.model";
import { API_RESPONSE_STATUS } from "../../constants/common.constant";

export interface IOrderSlice {
  orderResponse: IGetAllOrderResponse | null;
  maintenanceOrderFilterData: IMaintenanceOrderFilterData | null;
  availableHours: IAvailableHours[] | null;
  loading: boolean;
  error: any;
  status: string;
  loadingHours: boolean;
  loadingFilter: boolean;
  filterStatus: string;
  updateOrderLoading: boolean;
  updateOrderStatus: string;
}

const INITIAL_STATE = {
  orderResponse: null,
  maintenanceOrderFilterData: null,
  availableHours: null,
  loading: false,
  error: null,
  status: "idle",
  filterStatus: "idle",
  loadingHours: false,
  loadingFilter: false,
  updateOrderLoading: false,
  updateOrderStatus: "idle"
} as IOrderSlice;

export const getAllOrders = createAsyncThunk(
  "order/getAllOrders",
  orderAPI.getAllOrders
);

export const getAllAvailableHours = createAsyncThunk(
  "order/getAllAvailableHours",
  orderAPI.getAllAvailableHours
);

export const getMaintenanceOrderFilterData = createAsyncThunk(
  "order/getMaintenanceOrderFilterData",
  orderAPI.getMaintenanceOrderFilterData
);

export const getFilteredOrders = createAsyncThunk(
  "order/getFilteredOrders",
  orderAPI.getFilteredOrders
);

export const createOrderSchedule = createAsyncThunk(
  "order/createOrderSchedule",
  orderAPI.createOrderSchedule
);

export const updateOrderSchedule = createAsyncThunk(
  "order/updateOrderSchedule",
  orderAPI.updateOrderSchedule
);

const orderSlice = createSlice({
  name: "order",
  initialState: INITIAL_STATE,
  reducers: {  
  },
  extraReducers: (builder) => {
    builder
    .addCase(getMaintenanceOrderFilterData.pending, (state) => {
      state.loadingFilter = true;
      state.filterStatus = API_RESPONSE_STATUS.LOADING;
    })
    .addCase(getMaintenanceOrderFilterData.fulfilled, (state, action) => {
      state.loadingFilter = false;
      state.error = null;
      state.maintenanceOrderFilterData = action.payload.data;
      state.filterStatus = API_RESPONSE_STATUS.SUCCESS;
    })
    .addCase(getMaintenanceOrderFilterData.rejected, (state, action) => {
      state.loadingFilter = false;
      state.maintenanceOrderFilterData = null;
      state.error = action.payload;
      state.filterStatus = API_RESPONSE_STATUS.FAILED;
    })
    .addCase(getFilteredOrders.pending, (state) => {
      state.loading = true;
      state.status = API_RESPONSE_STATUS.LOADING;
    })
    .addCase(getFilteredOrders.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.orderResponse = action.payload.data;
      state.status = API_RESPONSE_STATUS.SUCCESS;
    })
    .addCase(getFilteredOrders.rejected, (state, action) => {
      state.loading = false;
      state.orderResponse = null;
      state.error = action.payload;
      state.status = API_RESPONSE_STATUS.FAILED;
    })
    .addCase(getAllAvailableHours.pending, (state) => {
      state.loadingHours = true;
      state.status = API_RESPONSE_STATUS.LOADING;
    })
    .addCase(getAllAvailableHours.fulfilled, (state, action) => {
      state.loadingHours = false;
      state.error = null;
      state.availableHours = action.payload.data;
      state.status = API_RESPONSE_STATUS.SUCCESS;
    })
    .addCase(getAllAvailableHours.rejected, (state, action) => {
      state.loadingHours = false;
      state.availableHours = null;
      state.error = action.payload;
      state.status = API_RESPONSE_STATUS.FAILED;
    })
    .addCase(createOrderSchedule.pending, (state) => {
      state.status = API_RESPONSE_STATUS.LOADING;
    })
    .addCase(createOrderSchedule.fulfilled, (state, action) => {
      state.status = API_RESPONSE_STATUS.SUCCESS;
    })
    .addCase(createOrderSchedule.rejected, (state, action) => {
      state.status = API_RESPONSE_STATUS.FAILED;
    })
    .addCase(updateOrderSchedule.pending, (state) => {
      state.updateOrderLoading = true;
      state.updateOrderStatus = API_RESPONSE_STATUS.LOADING;
    })
    .addCase(updateOrderSchedule.fulfilled, (state, action) => {
      state.updateOrderLoading = false;
      state.updateOrderStatus = API_RESPONSE_STATUS.SUCCESS;
    })
    .addCase(updateOrderSchedule.rejected, (state, action) => {
      state.updateOrderLoading = false;
      state.updateOrderStatus = API_RESPONSE_STATUS.FAILED;
    });
    
  },
});

export default orderSlice.reducer;
